import ApiService from '../api.services';

const PrepostCountService = {
  status: async function (month) {
    try {
      const res = await ApiService.get(`/api/prepost/count/status/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  services: async function (month) {
    try {
      const res = await ApiService.get(`/api/prepost/count/services/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  month: async function () {
    try {
      const res = await ApiService.get(`/api/prepost/count/month`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  state: async function (days = 30) {
    try {
      const res = await ApiService.get(`/api/prepost/count/state?days=${days}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  dashboardHome: async function (days = 30) {
    try {
      const res = await ApiService.get(`/api/prepost/dashboard/home?days=${days}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  dashboardSla: async function (months = 6) {
    try {
      const res = await ApiService.get(`/api/prepost/dashboard/sla?months=${months}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PrepostCountService;

export { PrepostCountService };

